import { render, staticRenderFns } from "./giftCardItem.vue?vue&type=template&id=22d8a9db&"
import script from "./giftCardItem.vue?vue&type=script&lang=js&"
export * from "./giftCardItem.vue?vue&type=script&lang=js&"
import style0 from "./giftCardItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports